<div class="container-fuild">
  <div class="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
    <div class="row">
      <div class="col-lg-5">
        <div
          class="d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100 bg-primary-transparent"
        >
          <div>
            <img src="../../../../assets/img/bg/authentication-bg-02.svg" alt="Img" />
          </div>
        </div>
      </div>
      <div class="col-lg-7 col-md-12 col-sm-12">
        <div class="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
          <div class="col-md-7 mx-auto vh-100">
            <!-- Show Thank You message after successful registration -->
            <div *ngIf="showThankYouMessage$ | async; else registrationForm" class="text-center">
              <div class="vh-100 d-flex flex-column justify-content-center p-4 pb-0">
                <div class="mx-auto mb-5 text-center">
                  <img src="../../../../assets/img/logo/logo.webp" class="img-fluid" alt="Logo" />
                </div>
                <h2>Thank You!</h2>
                <p>
                  Your registration was successful! We’ve sent you an email containing a secure link
                  to set your password.
                </p>
                <div class="text-center">
                  <h5 class="fw-normal text-dark mb-0">
                    <a routerLink="/auth/login" class="hover-a" (click)="handleSignInClick()"
                      >Sign In</a
                    >
                  </h5>
                </div>
                <div class="mx-auto mb-5 text-center">
                  <img
                    src="../../../../assets/img/register_email.png"
                    class="img-fluid"
                    alt="Logo"
                  />
                </div>
              </div>
            </div>
            <!-- Registration Form -->
            <ng-template #registrationForm>
              <form [formGroup]="form" (ngSubmit)="register()" class="vh-100">
                <div class="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                  <div class="mx-auto mb-5 text-center">
                    <img src="../../../../assets/img/logo/logo.webp" class="img-fluid" alt="Logo" />
                  </div>
                  <div>
                    <div class="text-center mb-3">
                      <h2 class="mb-2">Sign Up</h2>
                      <p class="mb-0">Please enter your details to sign up</p>
                    </div>

                    <!-- First Name Field -->
                    <div class="mb-3">
                      <label class="form-label" for="firstName">First Name</label>
                      <div class="input-group">
                        <input
                          appTrimInput
                          type="text"
                          formControlName="firstName"
                          appTrimInput
                          class="form-control border-end-0"
                        />
                        <span class="input-group-text border-start-0"
                          ><i class="ti ti-user"></i
                        ></span>
                      </div>
                      <div *ngIf="form.get('firstName')?.invalid && form.get('firstName')?.touched">
                        <span class="text-danger">{{ getErrorMessage('firstName') }}</span>
                      </div>
                    </div>

                    <!-- Last Name Field -->
                    <div class="mb-3">
                      <label class="form-label" for="lastName">Last Name</label>
                      <div class="input-group">
                        <input
                          appTrimInput
                          type="text"
                          formControlName="lastName"
                          appTrimInput
                          class="form-control border-end-0"
                        />
                        <span class="input-group-text border-start-0"
                          ><i class="ti ti-user"></i
                        ></span>
                      </div>
                      <div *ngIf="form.get('lastName')?.invalid && form.get('lastName')?.touched">
                        <span class="text-danger">{{ getErrorMessage('lastName') }}</span>
                      </div>
                    </div>

                    <!-- Business Name Field -->
                    <div class="mb-3">
                      <label class="form-label" for="businessName">Business Name</label>
                      <div class="input-group">
                        <input
                          appTrimInput
                          type="text"
                          formControlName="businessName"
                          appTrimInput
                          class="form-control border-end-0"
                        />
                        <span class="input-group-text border-start-0"
                          ><i class="ti ti-building"></i
                        ></span>
                      </div>
                      <div
                        *ngIf="
                          form.get('businessName')?.invalid && form.get('businessName')?.touched
                        "
                      >
                        <span class="text-danger">{{ getErrorMessage('businessName') }}</span>
                      </div>
                    </div>

                    <!-- Mobile Field -->
                    <div class="mb-3">
                      <label class="form-label" for="mobile">Mobile</label>
                      <div class="input-group">
                        <input
                          appTrimInput
                          type="text"
                          formControlName="mobile"
                          appTrimInput
                          class="form-control border-end-0"
                        />
                        <span class="input-group-text border-start-0"
                          ><i class="ti ti-mobile"></i
                        ></span>
                      </div>
                      <div *ngIf="form.get('mobile')?.invalid && form.get('mobile')?.touched">
                        <span class="text-danger">{{ getErrorMessage('mobile') }}</span>
                      </div>
                    </div>

                    <!-- Email Field -->
                    <div class="mb-3">
                      <label class="form-label" for="email">Email Address</label>
                      <div class="input-group">
                        <input
                          appTrimInput
                          type="email"
                          formControlName="email"
                          appTrimInput
                          appStrictEmail
                          class="form-control border-end-0"
                        />
                        <span class="input-group-text border-start-0"
                          ><i class="ti ti-mail"></i
                        ></span>
                      </div>
                      <div *ngIf="form.get('email')?.invalid && form.get('email')?.touched">
                        <span class="text-danger">{{ getErrorMessage('email') }}</span>
                      </div>
                    </div>

                    <!-- Submit Button -->
                    <div class="mb-3">
                      <button type="submit" class="btn btn-primary w-100" [disabled]="form.invalid">
                        <ng-container *ngIf="isLoading$ | async; else loading">
                          <span
                            class="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Signing Up...
                        </ng-container>
                        <ng-template #loading> Sign Up </ng-template>
                      </button>
                    </div>

                    <!-- Already Have an Account Link -->
                    <div class="text-center">
                      <h6 class="fw-normal text-dark mb-0">
                        Already have an account?
                        <a routerLink="/auth/login" class="hover-a">Sign In</a>
                      </h6>
                    </div>
                  </div>
                  <div class="mt-5 pb-4 text-center">
                    <p class="mb-0 textt-gray-9" [innerHTML]="copyrightText"></p>
                  </div>
                </div>
              </form>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
